import { fetchEndpoint } from "../network";

/**
 * 角色管理
 */

export default {
  // 列表
  list(params) {
    return fetchEndpoint("/create-platform/role", "GET", params);
  },
  //锁定
  lock(params) {
    return fetchEndpoint(
      "/create-platform/content/article/lock",
      "GET",
      params
    );
  },
  // 创建
  create(params) {
    return fetchEndpoint("/create-platform/role", "POST", params);
  },

  // 详情
  detail(params) {
    return fetchEndpoint("/create-platform/role/detail", "GET", params);
  },

  // 修改
  modify(params) {
    return fetchEndpoint("/create-platform/role/modify", "POST", params);
  },

  // 全部权限
  menes(params) {
    return fetchEndpoint("/create-platform/role/config", "GET", params);
  },

  // 删除
  remove(params) {
    return fetchEndpoint("/create-platform/role/delete", "POST", params);
  },
};
